import styles from './TableRow.module.scss';

type Props = {
  /**
   * The content to render within the component.
   * Typically a `TableTh` or `TableTd` component.
   */
  children: React.ReactNode;
};

/**
 * The `tr` tag; use to group data into rows.
 */
export const TableRow = (props: Props) => {
  return (
    <tr className={styles.tableRow} role="row" data-zds>
      {props.children}
    </tr>
  );
};
